module.exports = __webpack_public_path__ + "img/auto-reply.fe47735f.svg";